import { createBrowserRouter } from "react-router-dom";
import Survey from "./pages/Survey";
import SurveyWealth from "./pages/SurveyWealth";
import SurveyWealthResult from "./pages/SurveyWealthResult";

export const router = createBrowserRouter([
  {
    path: "/:code/:type/:id",
    element: <Survey />,
  },
  {
    path: "/wealth/:surveyId/:id",
    element: <SurveyWealth />,
  },
  {
    path: "/wealth/:surveyId/:id/report",
    element: <SurveyWealthResult />,
  },
]);
